// pages/PrivacyPolicy.jsx
import React from 'react';
import { useNavigate } from 'react-router-dom'; 
import { useEffect, useState ,useRef} from 'react';

const PrivacyPolicy = () => {
     const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
          // const [isServicesOpen, setIsServicesOpen] = useState(false);
          // const [isIndustriesOpen, setIsIndustriesOpen] = useState(false);
          // const [isCompanyOpen, setIsCompanyOpen] = useState(false);
        
          const toggleMobileMenu = () => {
            setIsMobileMenuOpen(!isMobileMenuOpen);
          };
        
          // const toggleServicesDropdown = () => {
          //   setIsServicesOpen(!isServicesOpen);
          // };
        
          // const toggleIndustriesDropdown = () => {
          //   setIsIndustriesOpen(!isIndustriesOpen);
          // };
        
          // const toggleCompanyDropdown = () => {
          //   setIsCompanyOpen(!isCompanyOpen);
          // };
    
      const [openDropdown, setOpenDropdown] = useState(null);
      const navRef = useRef(null);
    
      // Close dropdown on outside click
      useEffect(() => {
        const handleClickOutside = (event) => {
          if (navRef.current && !navRef.current.contains(event.target)) {
            setOpenDropdown(null);
          }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
      }, []);
    
      const toggleDropdown = (dropdown) => {
        setOpenDropdown(openDropdown === dropdown ? null : dropdown);
      };
      
      const navigate = useNavigate();
     
      const handleClick = () => {
        navigate("/Contact#contact-section");
      };
        const [isOpen, setIsOpen] = useState(false);
              
                // const toggleDropdown = () => {
                //   setIsOpen((prev) => !prev);
                // };
          
          
                const [isServicesOpen, setIsServicesOpen] = useState(false);
            const [isIndustriesOpen, setIsIndustriesOpen] = useState(false);
            const [isCompanyOpen, setIsCompanyOpen] = useState(false);
          
            // Toggle functions for dropdowns
            const toggleServicesDropdown = () => {
              setIsServicesOpen(!isServicesOpen);
              setIsIndustriesOpen(false);
              setIsCompanyOpen(false); // Close other dropdowns
            };
          
            const toggleIndustriesDropdown = () => {
              setIsIndustriesOpen(!isIndustriesOpen);
              setIsServicesOpen(false);
              setIsCompanyOpen(false); // Close other dropdowns
            };
          
            const toggleCompanyDropdown = () => {
              setIsCompanyOpen(!isCompanyOpen);
              setIsServicesOpen(false);
              setIsIndustriesOpen(false); // Close other dropdowns
            };
                const [word, setWord] = useState('Today');
          
            useEffect(() => {
              const interval = setInterval(() => {
                setWord((prev) => (prev === 'Today' ? 'Tomorrow' : 'Today'));
              }, 2000);
              return () => clearInterval(interval);
            }, []);
  

  const toggleSlider = () => {
    setIsOpen((prev) => !prev);
  };

  return (
    <>
     
     <div className="max-w-5xl mx-auto px-4 py-12 font-poppins text-gray-800">
    {/* Main heading */}
    <h1 className="text-4xl font-bold mb-4">Privacy Policy</h1>

    {/* Subtitle */}
    <p className="text-xl font-medium text-gray-700 mb-10">
      Welcome to Lentera Technologies. By using our site or apps you agree to the practices
      described below.
    </p>

    <hr className="mb-10" />

    {/* Welcome paragraphs */}
    <p className="mb-6">
      As part of our process&nbsp;— for example when you register an account or contact us through
      social media — we collect certain information to fulfil your needs.
    </p>
    <p className="mb-10">
      This policy for Lentera Technology Private Limited and Ticketezee explains what personal data
      we collect, how we use it, how we protect it, whether it is disclosed and how you can access
      or rectify it.
    </p>

    {/* Consent */}
    <h2 className="text-xl font-semibold mb-3">Consent</h2>
    <p className="mb-10">
      By using our website, you hereby consent to this Privacy Policy and agree to its terms.
    </p>

    {/* 1. Information we collect */}
    <h2 className="text-xl font-semibold mb-3">1. Information We Collect</h2>

    <h3 className="font-semibold mb-1">Basic Information</h3>
    <p className="mb-6">
      When you visit our site we may ask for and sometimes store details such as your name, email,
      telephone number, address, date of birth, etc.
    </p>

    <h3 className="font-semibold mb-1">Automatic Information</h3>
    <p className="mb-6">
      We also receive certain data automatically from your device&nbsp;— IP address, browser type,
      session times and the items you searched for or viewed.
    </p>

    <h3 className="font-semibold mb-1">Use of Cookies</h3>
    <p className="mb-10">
      Like many websites, we use cookies to enhance your experience and to recognize you between
      visits. See your browser’s help section to disable cookies (site functionality may be limited).
    </p>

    {/* 2. How we use your information */}
    <h2 className="text-xl font-semibold mb-3">2. How Do We Use Your Information</h2>
    <p className="mb-6">
      We use a cookie to identify you the next time you visit and may send you emails, promotions or
      other information (opt‑in/out any time). We also perform market research and customer
      profiling to show content we think may interest you.
    </p>

    {/* 3. Security */}
    <h2 className="text-xl font-semibold mb-3">3. Security of Your Information</h2>
    <p className="mb-6">
      We employ secure‑server software (SSL) to encrypt data you send and maintain strict measures
      to protect stored data from unauthorized access. Payment‑card details are encrypted and never
      stored by us.
    </p>

    {/* 4. Disclosure */}
    <h2 className="text-xl font-semibold mb-3">4. To Whom Do We Disclose This Information?</h2>
    <p className="mb-6">
      Card details go directly to our banking partners. We may share your info with trusted third
      parties we believe could interest you (you can opt‑out). We may also disclose data when
      required by law or to protect our rights and those of our customers.
    </p>

    {/* 5. General */}
    <h2 className="text-xl font-semibold mb-3">5. General</h2>
    <p className="mb-6">
      Your use of the site signifies consent to the practices above. Protect your data: always log
      off shared computers. Contact us any time if you are unsure about the information we hold.
    </p>

    {/* -----   MOBILE‑APP SUB‑SECTION   ----- */}
    <hr className="my-12" />

    <h2 className="text-2xl font-bold mb-4">T2 App – Trip & Vehicle Tracking</h2>
    <p className="mb-6">
      This section explains how we collect, use and protect personal and location data when you use
      the T2 mobile application.
    </p>

    {/* 1. Information */}
    <h3 className="font-semibold mb-1">1. Information We Collect</h3>
    <p className="mb-4">
      We collect personal data you provide voluntarily&nbsp;— name, email, contact number, etc.
    </p>
    <p className="mb-6">
      <span className="font-semibold">Location Data&nbsp;—</span> With tracking enabled, we collect
      real‑time location of your vehicle/device solely to provide tracking services.
    </p>

    {/* 2. Third‑party providers */}
    <h3 className="font-semibold mb-1">2. Third‑Party Service Providers</h3>
    <p className="mb-6">
      Trusted providers helping operate the app may access your data under confidentiality
      agreements and only to deliver requested services.
    </p>

    {/* 3. Location tracking */}
    <h3 className="font-semibold mb-1">3. Location Tracking</h3>
    <p className="mb-6">
      You may enable or disable tracking in the app settings; disabling may limit certain features.
    </p>

    {/* 4. General */}
    <h3 className="font-semibold mb-1">4. General</h3>
    <p className="mb-10">
      Using the app signifies consent to these practices. Protect your data by logging off shared
      devices. Contact us with any concerns.
    </p>

    {/* Contact */}
    <h2 className="text-xl font-semibold mb-3">Contact Us</h2>
    <p>
      If you have additional questions or require more information about this Privacy Policy, do not
      hesitate to contact us.
    </p>
  </div>

    </>
  );
};

export default PrivacyPolicy;